import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs";

import { ChangeDetectionStrategy, Component, inject, resource } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";

import { DEFAULT_LANGUAGE } from "../../../../app/constants";
import { NEWS_REPOSITORY } from "../../../../app/news/domain/ports/news-repository.port";
import { NewsHeaders } from "../../../../app/news/ui/components/news-headers-list/news-headers-list.component";

@Component({
  selector: "news-container",
  template: `<news-headers [newsItems]="newsResource.hasValue() ? newsResource.value() : []" />`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NewsHeaders],
})
export class NewsContainer {
  private readonly news = inject(NEWS_REPOSITORY);
  private readonly translate = inject(TranslateService);

  private readonly currentLang = toSignal(this.translate.onLangChange.pipe(map((e) => e.lang)), {
    initialValue: this.translate.getCurrentLang() ?? DEFAULT_LANGUAGE,
  });

  protected newsResource = resource({
    params: () => this.currentLang(),
    loader: ({ params }) => this.news.getNewsItemsForLanguage(params),
  });
}
